import { _ } from "../../../core/polyglot/polyglot.js";
import AccountingDocumentState from "../../shared/documentInfrastructure/AccountingDocumentState.js";
import ComparisonReportTemplate from "../../../models/ComparisonReportTemplate.js";

/**
 * Hold and manage the state for the comparison tool document.
 */
export default class ComparisonToolDocumentState extends AccountingDocumentState {
	async setup({ onContentUpdateRequest }, ...rest) {
		await super.setup(rest);

		this._onContentUpdateRequest = onContentUpdateRequest;
	}

	getReportTemplateItems() {
		return [...this._reportTemplatesRowsItems].map((item) => {
			item.selected = this._isReportIdActive(item.value.id);
			return item;
		});
	}

	setReportTemplate(reportTemplate) {
		this._comparisonReportTemplate.setReportTemplate(reportTemplate);
		return this.updateReport();
	}

	getForecastEstimateById(forecastEstimateId) {
		return this._comparisonReportTemplate.getForecastEstimateById(
			forecastEstimateId,
		);
	}

	getPastRepeatingColumnTemplate() {
		return this._comparisonReportTemplate.getPastRepeatingColumnTemplate();
	}

	getFutureRepeatingColumnTemplate() {
		return this._comparisonReportTemplate.getFutureRepeatingColumnTemplate();
	}

	getSubColumnSpecs() {
		return this._comparisonReportTemplate.getSubColumnSpecs();
	}

	setSubColumnSpecs(specs) {
		this._comparisonReportTemplate.setSubColumnSpecs(specs);
		return this.updateReport();
	}

	getSummarySpecs(...rest) {
		return this._comparisonReportTemplate.getSummarySpecs(...rest);
	}

	setSummarySpecs(...rest) {
		this._comparisonReportTemplate.setSummarySpecs(...rest);
		return this.updateReport();
	}

	setPeriodType(periodType) {
		this._comparisonReportTemplate.setPeriodType(periodType);
		return this.updateReport();
	}

	getLargerPeriodTypes() {
		return this._comparisonReportTemplate.getLargerPeriodTypes();
	}

	getForecastEstimates() {
		return this._forecastEstimates;
	}

	getBudgets() {
		return this._budgets;
	}

	getReport() {
		return this._report;
	}

	async onPeriodChange(period) {
		const reportTemplate =
			this._comparisonReportTemplate.changePeriod(period);

		this._report = await this._service.changePeriodOfReport({
			period,
			reportTemplate,
		});
	}

	isBimesterEnabled() {
		return false;
	}

	isYearToDateEnabled() {
		return false;
	}

	async updateReport() {
		const reportTemplate =
			this._comparisonReportTemplate.updateReportTemplate();

		this._report = await this._service.updateReport({
			reportTemplate,
		});

		this._onContentUpdateRequest?.();

		return this._report;
	}

	_setupInitialData({
		chartOfAccounts,
		period,
		forecastEstimates,
		budgets,
		incomeStatement,
		balanceSheet,
	}) {
		this._chartOfAccounts = chartOfAccounts;
		this._forecastEstimates = forecastEstimates;
		this._budgets = budgets;

		this._reportTemplatesRowsItems = [
			{
				label: _("Profit & Loss"),
				value: {
					id: incomeStatement.getId(),
					rows: incomeStatement.getRows(),
				},
			},
			{
				label: _("Balance Sheet"),
				value: {
					id: balanceSheet.getId(),
					rows: balanceSheet.getRows(),
				},
			},
		];

		const initialReport = this._reportTemplatesRowsItems[0].value;

		this._comparisonReportTemplate = new ComparisonReportTemplate({
			period,
			forecastEstimates,
			rowTemplates: initialReport.rows,
			reportId: initialReport.id,
		});

		return this.updateReport();
	}

	_isReportIdActive(id) {
		return this._comparisonReportTemplate.hasReportId(id);
	}
}
